/**
 * "Receive calls" (Profile → Call readiness), web's version of Android's CallPreferences and iOS's
 * CallPreferences: whether this browser rings for incoming calls. Web has no push token to
 * unregister — calls arrive over the Chat SDK's realtime connection while a tab is open — so off
 * means CallProvider ignores them here. It doesn't decline them, so the user's other devices still
 * ring. Kept per browser in localStorage; signing out leaves it alone.
 */
const KEY = 'connect.receiveCalls';

export function receiveCalls(): boolean {
  try {
    return localStorage.getItem(KEY) !== 'false';
  } catch {
    return true;
  }
}

export function setReceiveCalls(on: boolean): void {
  try {
    localStorage.setItem(KEY, on ? 'true' : 'false');
  } catch {
    // Storage blocked: the choice lasts for this page only.
  }
}
